<template>
  <a-modal title="处方详情" :width="980" :visible="visible" :maskClosable="false"
    v-if="hackReset" @cancel="handleCancel">
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="ok" @click="handleSubmit" :loading="confirmLoading" v-show="this.footerType">
        确认发药
      </a-button>
    
    </template>

    <div class="viewDetial-tiem">
      <div class="viewDetial-title">
        就诊人信息
        <div v-if="this.deliveryWay== '0'" style="flex: 1; text-align: right;color: #e23b50;"> {{ this.loadUser.insured == '1' ? '已保价' : '未保价'  }} </div>
      </div>
      <a-row style="height:30px">
        <a-col :span="8">
          <label>姓名：{{this.loadUser.patientName}}</label>
        </a-col>
        <a-col :span="8">
          <label>就诊科室：<a>{{ this.loadUser.deptName }}</a> </label>
        </a-col>
        <a-col :span="8">
          <label>状态：<a>{{this.loadUser.orderState == 0? '未交易' :this.loadUser.orderState == 1? '订单挂起': this.loadUser.orderState == 2?
          '订单成功':this.loadUser.orderState == 3? '订单失败':this.loadUser.orderState == 4? '订单取消': this.loadUser.orderState == 5?
          '订单关闭':this.loadUser.orderState == 6? '全退费':this.loadUser.orderState == 7? '部分退费':this.loadUser.orderState == 8?
          '待收货': this.loadUser.orderState == 9? '已完成': this.loadUser.orderState == 10? '待取药':''}}</a> </label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="8">
          <label>诊断： <span style="padding-right:10px" v-for="(item,key) in this.loadUser.diaName" :key="key">{{ item +
          '&nbsp;&nbsp;' }} </span> </label>
        </a-col>
        <a-col :span="8">
          <label>就诊医师： {{ this.loadUser.recDrName }} </label>
        </a-col>
        <a-col :span="8">
          <label>地址：{{ this.loadUser.provinceName + ' ' + this.loadUser.cityName + ' ' + this.loadUser.disName + '' + this.loadUser.addrHome }}</label>
        </a-col>
      </a-row>
      <div style="border-bottom: 1px dotted #ccc;margin: 10px 0 ;">
      
      </div>
      <a-row style="height:30px">
        <a-col :span="8">
          <label>开方日期：{{ this.loadUser.createTime }}</label>
        </a-col>
        <a-col :span="8">
          <label>药房： {{ this.loadUser.negotiationFlag   == 1?'无' :  this.loadUser.pharmacyName }}</label>
        </a-col>
        <a-col :span="8">
          <label>审核药师： {{ this.loadUser.pharName }}</label>
        </a-col>
        
      </a-row>
      <a-row style="height:30px" v-show="this.category != 1 ">
        <a-col :span="8">
          <label>处方贴数：{{ this.loadUser.countNum }}</label>
        </a-col>
        <a-col :span="8">
          <label>单次剂量： {{ this.loadUser.onceDosage ? this.loadUser.onceDosage  + 'ml'  : ''}}</label>
        </a-col>
        <a-col :span="8">
          <label>频次： {{ this.loadUser.freq }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px;margin-bottom:10px">
        <a-col :span="8" v-show="this.category != 1">
            <label>用法： {{ this.loadUser.useType }}</label>
          </a-col>
        <a-col :span="8">
          <label>处方编号： {{ this.loadUser.recipeNo }}</label>
        </a-col>
        <a-col :span="8">
          <label>外配药房： {{ this.loadUser.negotiationFlag == 0 ? '否' : this.loadUser.negotiationFlag == 1 ? '是' : '' }} </label>
        </a-col>
      </a-row>
    </div>


    <div>
      <div class="viewDetial-title">药房信息</div>
      <!-- <div class="viewDetial_table_title">
        <div>订单编号：{{this.loadUser.orderId}}</div>
        <div>药方类型：{{this.loadUser.category == 1 ? '西药/中成药' :this.loadUser.category == 2 ? '中药' : ''  }}</div>
        <div>订单状态：{{this.loadUser.orderState == 0? '未交易' :this.loadUser.orderState == 1? '订单挂起': this.loadUser.orderState == 2? '订单成功':this.loadUser.orderState == 3? '订单失败':this.loadUser.orderState == 4? '订单取消': this.loadUser.orderState == 5? '订单关闭':this.loadUser.orderState == 6? '全退费':this.loadUser.orderState == 7? '部分退费':this.loadUser.orderState == 8? '待收货': this.loadUser.orderState == 9? '已完成': this.loadUser.orderState == 10? '待取药':''}}</div>
      </div> -->
      <div>
        <s-table ref="table" :columns="columns" :data="loadData" :rowKey="(record) => record.mediId">
          <a slot="mediCode" slot-scope="text, record">{{record.mediCode}}</a>

          <!-- <a slot="freq" slot-scope="text, record">{{ record.useType +','+record.freq  }}</a> -->

          <a slot="wmOnceDosage" slot-scope="text, record">{{( record.wmOnceDosage== undefined? '' :record.wmOnceDosage) + '' + (record.mediUnit == undefined ? '' : record.mediUnit ) + '/次,' + (record.freqName == undefined?'' : record.freqName )
            }}</a>

        </s-table>
        <div class="totalPrice">
          <!-- <a-row style="height:30px;line-height:30px">
            <a-col :span="12" style="padding-left:5px">
              <label v-show="this.loadUser.category != '2'">数量：{{this.loadUser.totalCount}}</label>
            </a-col>
            <a-col :span="12">
              <label>总价：{{this.loadUser.totalPrice}}</label>
            </a-col>
          </a-row> -->
          <div class="totalPrice">
            <a-row style="height:30px;line-height:30px;font-weight: bold;">
              <a-col :span="5" style="padding-left:5px">
                <label>总计：</label>
              </a-col>
              <a-col :span="10" style="text-align: right;">
                <label>{{this.loadUser.totalCount}}</label>
              </a-col>
              <a-col :span="6" style="text-align: right;">
                <div v-if="this.loadUser.originalFee">合计：{{this.loadUser.originalFee}}</div>
                <div v-if="this.loadUser.couponFee">优惠：{{(Number(this.loadUser.couponFee)).toFixed(2)}}</div>


                <div v-if="this.loadUser.couponFee && this.loadUser.totalPrice" style="color: #e23b50;">实付款: {{this.loadUser.totalPrice}}</div>
                <div v-else-if="!this.loadUser.couponFee && this.loadUser.totalPrice">实付款: {{this.loadUser.totalPrice}}</div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>


  </a-modal>
</template>

<script>
import { STable } from '@/components';
import moment from 'moment'
import { recipeDetial, recipeConfirm } from '@/api/modular/interhospital/recipetable/recipeManage'
export default {
  components: {
    STable
  },
  data() {
    return {
      queryParam: {},
      parameter: {},
      hackReset: true,
      footerType: true,
      deliveryWay: "",
      category :'',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 }
      },
      verifytimeDateString: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      loadUser: [],
      loadData: parameter => {
        return new Promise(async (resolve, reject) => {
          const res = await recipeDetial(Object.assign(parameter, this.queryParam));
          this.loadUser = res.data;
          resolve(res.data.medielist);
        });
      },
      columns : [],
      columnsXi: [
        {
          title: '药品编号',
          align: 'center',
          dataIndex: 'mediCode',
          scopedSlots: { customRender: 'mediCode' },
        },
        {
          title: '药品名称',
          align: 'left',
          dataIndex: 'mediName'
        },
        
        {
          title: '规格',
          align: 'left',
          dataIndex: 'specification'
        },
        {
          title: '用药途径',
          align: 'left',
          dataIndex: 'useType'
        },
        {
          title: '剂量，频次',
          align: 'left',
          dataIndex: 'wmOnceDosage',
          scopedSlots: { customRender: 'wmOnceDosage' },
        },
        {
          title: '数量',
          align: 'center',
          dataIndex: 'mediNum'
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'baseUnit'
        },
        {
          title: '单价',
          align: 'center',
          dataIndex: 'unitPrice'
        },
        {
          title: '金额',
          align: 'right',
          dataIndex: 'kindTotalPrice'
        }, 
        {
          title: '用药天数',
          align: 'center',
          dataIndex: 'dayNum',
          // scopedSlots: { customRender: 'freq' },
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remarks'
        }

      ],
      columnsZhong: [
        {
          title: '药品编号',
          align: 'center',
          dataIndex: 'mediCode',
          scopedSlots: { customRender: 'mediCode' },
        },
        {
          title: '药品名称',
          align: 'left',
          dataIndex: 'mediName'
        },

        {
          title: '规格',
          align: 'left',
          dataIndex: 'specification'
        },
        {
          title: '用药途径',
          align: 'left',
          dataIndex: 'useType'
        },
        {
          title: '数量',
          align: 'center',
          dataIndex: 'mediNum'
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'baseUnit'
        },
        {
          title: '单价',
          align: 'center',
          dataIndex: 'unitPrice'
        },
        {
          title: '金额',
          align: 'right',
          dataIndex: 'kindTotalPrice'
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remarks'
        }

      ],
    }
  },
  created() {
    this.loadUser = [];
  },
  methods: {
    moment,
    // 初始化方法  订单详情  ， 底部弹框类型 ， 发药方式
    add(record, footerType, deliveryWay) {
      this.footerType = footerType;
      this.deliveryWay = deliveryWay;

      this.queryParam.id = record.id;
      this.parameter.orderId = record.id;

      this.category =record.category;
      if (record.category == 1) { // 西药
        this.columns = this.columnsXi
      } else {
        this.columns = this.columnsZhong
      }

      this.visible = true;
    },


   
    /**
        * 点击确认发药
        */
    handleSubmit() {
      this.confirmLoading = true;
      recipeConfirm(this.parameter).then(res => {
        if (res.code == '200') {
          this.confirmLoading = false;
          this.$message.success('发药成功');
          this.visible = false;
          this.$parent.handleOk();
          this.$refs.table.refresh()
        } else {
          this.confirmLoading = false;
          this.$message.error(res.message);
        }
      }).catch(error => {
        this.confirmLoading = false;
      })
    },

 
    //点击取消按钮
    handleCancel() {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(() => {
          this.hackReset = true;
        })
    },

  },
}
</script>
<style lang="less" scoped>
.viewDetial-title {
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  display: flex;
}

.viewDetial_table_title{
  height: 40px;
  display: flex;
  background-color: #d7d7d7;
  border-radius: 5px;
  &>div{
    flex: 1;
    text-align: center;
    line-height: 40px;
  }
}

/deep/.s-table-tool {
  display: none;
}

.totalPrice {
  line-height: 30px;
  padding: 0 30px;
}

.detialImage {
  width: 80px;
  height: 30px;
  margin: 0 10px;
  cursor: pointer;

  // transform: rotate();
}
</style>
